module.exports = __webpack_public_path__ + "img/logo-logo-fundanow-g.7ff25e87.svg";